import * as types from '../actions/v2DashboardTypes';

const initialState = {
    isOpen: false,
};

const v2DashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.OPEN_V2_DASHBOARD:
            return { ...state, isOpen: true };
        case types.CLOSE_V2_DASHBOARD:
            return { ...state, isOpen: false };
        default:
            return state;
    }
};

export default v2DashboardReducer;
